/** @mixin tableResetMixin */
/**
 * Defensive reset styles for tables.
 *
 * @example
 * import { tableResetMixin } from '@zillow/constellation';
 *
 * const Component = styled.table`
 *     ${tableResetMixin}
 * `;
 *
 * <Component />
 *
 * @method
 * @return {CSSObject}
 */
export var tableResetMixin = function tableResetMixin() {
  return "\n    display: table;\n    width: 100%;\n    background: none;\n    text-align: left;\n    border: 0;\n    border-collapse: collapse;\n    border-spacing: 0;\n    font-variant-numeric: tabular-nums;\n\n    tr:nth-child(n),\n    th,\n    td {\n        border: 0;\n        background: none;\n    }\n";
};